const paths = {
  addTicket: '/vehicleFuel/ticket/add',
  importTicket: '/vehicleFuel/ticket/import',
  recordMultiple: '/vehicleFuel/ticket/multiple',
  consolidatedReport: '/vehicleFuel/reports/consolidated',
  byUnitReport: '/vehicleFuel/reports/byUnit',
  fuelTicketsReport: '/vehicleFuel/reports/fuelTicketsReport'
};

export default paths;
